<template>
  <div class="left-wrap">
    <ul class="menu-list">
      <template v-if="certificationAuth">
        <!--        <li class="menu-list-item">-->
        <!--          <router-link-->
        <!--            class="menu zxgz"-->
        <!--            :class="{-->
        <!--            active: $route.path.indexOf('/judicialService/safeguard') !== -1-->
        <!--          }"-->
        <!--            to="/judicialService/safeguard"-->
        <!--          >公证证书</router-link-->
        <!--          >-->
        <!--        </li>-->
        <li class="menu-list-item">
          <router-link
            class="menu bgh"
            :class="{
            active: $route.path.indexOf('/judicialService/baoguanhan') !== -1
          }"
            to="/judicialService/baoguanhan"
          >保管函</router-link
          >
        </li>
        <li class="menu-list-item">
          <router-link
            class="menu ezj"
            :class="{
            active: $route.path.indexOf('/judicialService/eEvidence') !== -1
          }"
            to="/judicialService/eEvidence"
          >E证据</router-link
          >
        </li>
        <li class="menu-list-item">
          <router-link
            class="menu ezj"
            :class="{
            active: $route.path.indexOf('/judicialService/technicalReport') !== -1
          }"
            to="/judicialService/technicalReport"
          >电子签署技术报告</router-link
          >
        </li>
      </template>
      <!-- /judicialService/arbitration-->
      <li class="menu-list-item" v-if="arbitrationAuth">
        <router-link
          class="menu ezj"
          :class="{
            active: $route.path.indexOf('/judicialService/applyArbitration') !== -1
          }"
          to="/judicialService/applyArbitration"
        >仲裁管理</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import { gantConf } from "@/assets/js/utils/jurisdiction";

export default {
  name: "leftTab",
  data() {
    return {
      isOpen: true
    };
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    arbitrationAuth(){
      return (this.currentAuthUser.corpId && this.currentAuthUser.perms.includes(gantConf.arbitrate)) || !this.currentAuthUser.corpId;
    },
    certificationAuth() {
      return (this.currentAuthUser.corpId && this.currentAuthUser.perms.includes(gantConf.memberCert)) || !this.currentAuthUser.corpId;
    },
  },
};
</script>

<style scoped lang="less">
.left-wrap {
  width: 100%;
  height: 100%;
  padding: 10px 0 15px;
  width: 230px;
  background-color: #ffffff;
  .menu-list {
    width: 100%;
  }
  .menu-list-item {
    width: 100%;
  }
  .sub-menu {
    width: 100%;
    height: 0;
    overflow: hidden;
    transition: height 200ms;
    &.open-menu {
      height: 120px;
      transition: height 200ms;
      overflow: visible;
    }
  }
  .sub-menu-item {
    width: 100%;
  }
  .menu {
    width: 100%;
    height: 40px;
    display: flex;
    cursor: pointer;
    align-items: center;
    box-sizing: border-box;
    padding-left: 30px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 40px;
    color: rgba(41, 2, 2, 0.65);
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 15px;
      height: 15px;
      margin-right: 10px;
      background-size: cover;
      background-repeat: no-repeat;
    }
    &.zxgz::before {
      background-image: url("/static/images/arbitation/safeguard.png");
    }
    &.bgh::before {
      background-image: url("/static/images/arbitation/baoguanhan.png");
    }
    &.ezj::before {
      background-image: url("/static/images/arbitation/ezj.png");
    }
    &.zxzc::before {
      background-image: url("/static/images/arbitation/arbitration.png");
    }
    &:hover {
      background-color: #f9f6f6;
    }
    &.active {
      color: #ec1c1c;
      background-color: #eeeeee;
      &.zxgz::before {
        background-image: url("/static/images/arbitation/safeguardHover.png");
      }
      &.bgh::before {
        background-image: url("/static/images/arbitation/baoguanhanHover.png");
      }
      &.ezj::before {
        background-image: url("/static/images/arbitation/ezjHover.png");
      }
      &.zxzc::before {
        background-image: url("/static/images/arbitation/arbitrationHover.png");
      }
    }
    &.expanded::after {
      content: "";
      display: block;
      width: 12px;
      height: 12px;
      position: absolute;
      top: 50%;
      margin-top: -5px;
      left: 5px;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("/static/images/judicialService/icon-right-jt.png");
      transition: all 200ms;
    }
    &.expanded.open-menu {
      &::after {
        transform: rotate(90deg);
        transition: all 200ms;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/judicialService/leftTab.vue